import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReviewComponent from '../global/review-component';
import ReviewAverageComponent from '../global/review-average-component';

import { addResponseToReview } from './actions'


const mapStateToProps = state => ({
  listing: state.BrowseListings.selectedListing,
});

class ListingReviewsComponent extends Component {
  constructor(props) {
    super(props);
  }

  reviewResponseOnSubmit = (values) => {
    let { dispatch } = this.props;
    dispatch(addResponseToReview(values.reviewId, values.response));
  }

  renderReview(review, name) {
    return (<ReviewComponent key={review._id} review={review} type="owner" responderName={name} />)
  }

  compareReviews(a, b) {
    let aDate = new Date(a.createdDate);
    let bDate = new Date(b.createdDate);
    if (aDate > bDate) { return -1 }
    if (aDate < bDate) { return 1; }
    return 0;
  }

  render() {
    let { listing } = this.props;
    if (!listing) return (<div></div>)
    let profileName = !listing.userId ? null : `${listing.userId.firstName} ${listing.userId.lastName.substr(0, 1)}.`;
    return (
      <div className="listing-reviews">
        <h5>Ratings &amp; Reviews</h5>
        <div className="row">
          <div className="col-12 mt-3 p-0">
            <ReviewAverageComponent reviews={listing.reviews} averageRating={listing.averageRating} />
          </div>
        </div>
        {(!listing.reviews || listing.reviews.length === 0)
          ? (<div />)
          : listing.reviews.sort(this.compareReviews).map(r => this.renderReview(r, profileName))
        }
      </div>
    );
  }
}

export default connect(mapStateToProps)(ListingReviewsComponent);
